import { Component, OnInit } from '@angular/core'
import { Params } from '@angular/router'

import { metaDataContent } from '../../../../../locale/meta-data/meta-data.content.en'
import { BreadcrumbLink } from '../../../../shared/interfaces/breadcrumb-link.interface'
import { BreadcrumbService } from '../../../../shared/services/breadcrumb.service'
import { MetaService } from '../../../../shared/services/meta.service'

@Component({
  selector: 'app-tools-catalogue-overview',
  templateUrl: './tools-catalogue-overview.component.html',
  styleUrls: ['./tools-catalogue-overview.component.scss']
})
export class ToolsCatalogueOverviewComponent implements OnInit {
  searchGroups: {
    name: string
    searches: { name: string; path: string; queryParams: Params }[]
  }[] = [
    {
      name: 'Popular technical searches',
      searches: [
        {
          name: 'Technical tools to remove bias',
          path: '/catalogue/tools',
          queryParams: {
            approachIds: 1,
            objectiveIds: 2,
            orderBy: 'dateDesc'
          }
        },
        {
          name: 'Technical tools to audit AI systems',
          path: '/catalogue/tools',
          queryParams: {
            terms: 'audit',
            approachIds: 1,
            objectiveIds: 2,
            orderBy: 'dateDesc'
          }
        },
        {
          name: 'Technical  tools for robust and secure data collection and processing',
          path: '/catalogue/tools',
          queryParams: {
            approachIds: 1,
            lifecycleIds: 5,
            objectiveIds: 8,
            orderBy: 'dateDesc'
          }
        },
        {
          name: 'Technical tools for reskilling or upskilling',
          path: '/catalogue/metrics',
          queryParams: {
            approachIds: 1,
            objectiveIds: 6
          }
        },
        {
          name: 'Metrics to measure model performance',
          path: '/catalogue/metrics',
          queryParams: {
            objectiveIds: 4
          }
        },
        {
          name: 'Metrics to measure fairness',
          path: '/catalogue/metrics',
          queryParams: {
            objectiveIds: 2
          }
        },
        {
          name: 'Metrics to measure privacy',
          path: '/catalogue/metrics',
          queryParams: {
            objectiveIds: 5
          }
        }
      ]
    },
    {
      name: 'Popular non-technical searches',
      searches: [
        {
          name: 'Educational tools for reskilling or upskilling',
          path: '/catalogue/tools',
          queryParams: {
            approachIds: 2,
            objectiveIds: 6,
            orderBy: 'dateDesc'
          }
        },
        {
          name: 'Procedural tools for trustworthy AI in finance',
          path: '/catalogue/tools',
          queryParams: {
            approachIds: 3,
            targetSectorIds: 11,
            orderBy: 'dateDesc'
          }
        },
        {
          name: 'Procedural tools for health professionals',
          path: '/catalogue/tools',
          queryParams: {
            approachIds: [3, 2],
            targetSectorIds: 9,
            orderBy: 'dateDesc'
          }
        },
        {
          name: 'AI certifications and quality marks',
          path: '/catalogue/tools',
          queryParams: {
            approachIds: [3, 2],
            toolTypeIds: [20, 21],
            orderBy: 'dateDesc'
          }
        },
        {
          name: 'Documentation tools to increase transparency',
          path: '/catalogue/tools',
          queryParams: {
            approachIds: [3, 2],
            objectiveIds: 11,
            toolTypeIds: 17,
            orderBy: 'dateDesc'
          }
        },
        {
          name: 'Tools from labour unions',
          path: '/catalogue/tools',
          queryParams: {
            stakeholderGroupIds: 8
          }
        },
        {
          name: 'Procedural tools for auditing AI systems',
          path: '/catalogue/tools',
          queryParams: {
            orderBy: 'dateDesc',
            approachIds: 3,
            toolTypeIds: 1
          }
        }
      ]
    }
  ]

  breadcrumbLinks: BreadcrumbLink[]

  constructor(
    metaService: MetaService,
    private breadcrumbService: BreadcrumbService
  ) {
    metaService.setTags(metaDataContent.toolCatalogOverview)
  }

  ngOnInit(): void {
    this.breadcrumbLinks = this.breadcrumbService.getBreadCrumbLinks(
      'toolCatalog',
      [
        {
          label: 'Overview',
          path: '/catalogue/overview'
        }
      ]
    )
  }
  getOptionQueryParams(queryParamName: string, value: number): Params {
    const params: Params = {}
    params[queryParamName] = value
    return params
  }
}
